import { defineComponent as D, ref as w, watch as W, createBlock as F, createCommentVNode as y, openBlock as b, resolveDynamicComponent as O, h as v, mergeModels as A, useModel as U, onMounted as P, watchEffect as j, createElementBlock as C, Fragment as R, createVNode as g, Transition as z, withCtx as L, createElementVNode as e, normalizeClass as J, toDisplayString as r, withDirectives as N, vModelCheckbox as M } from "vue";
const G = /* @__PURE__ */ D({
  __name: "Markdown",
  props: {
    markdown: {},
    render: { type: Function }
  },
  setup(k) {
    const c = k, a = w();
    W(
      () => c.markdown,
      async () => {
        const i = await (await import("./marked.esm-CSRRKLjJ.js")).marked(c.markdown);
        a.value = new DOMParser().parseFromString(i, "text/html");
      },
      { immediate: !0 }
    );
    const p = (i) => {
      const s = Object.fromEntries(Array.from(i.attributes).map((t) => [t.name, t.value]));
      return i.tagName.toLowerCase() === "a" ? v("a", { ...s, target: "_blank" }, o(Array.from(i.childNodes))) : v(i.tagName.toLowerCase(), s, o(Array.from(i.childNodes)));
    }, o = (i) => i.map((s) => {
      if (s instanceof Element) {
        const t = p(s);
        return c.render ? c.render(t, s) : t;
      } else return s instanceof Text && s.textContent !== null ? s.textContent : "";
    }), m = (i) => v("article", {}, o(Array.from(i.body.childNodes)));
    return (i, s) => a.value ? (b(), F(O(m(a.value)), { key: 0 })) : y("", !0);
  }
}), I = (k, c) => {
  const a = k.__vccOpts || k;
  for (const [p, o] of c)
    a[p] = o;
  return a;
}, h = /* @__PURE__ */ I(G, [["__scopeId", "data-v-14565d62"]]), K = {
  key: 0,
  class: "cookie-banner-wrapper"
}, q = { class: "cookie-banner-info-text" }, H = { class: "button-group" }, Q = { class: "button-group" }, X = {
  key: 0,
  class: "cookie-settings-popup-wrapper"
}, Y = { class: "cookie-settings-popup" }, Z = { class: "title-wrapper" }, ee = { class: "cookie-settings-info-text" }, oe = { class: "cookie-groups-list" }, ne = { class: "cookie-group" }, te = { class: "label" }, ie = { class: "actions" }, se = { class: "necessary-label" }, ae = { class: "cookie-group" }, le = { class: "label" }, re = { class: "actions" }, ce = { class: "cookie-group-info-text" }, ue = { class: "cookie-group" }, de = { class: "label" }, ke = { class: "actions" }, ge = { class: "cookie-group-info-text" }, pe = /* @__PURE__ */ D({
  __name: "CookieBanner",
  props: /* @__PURE__ */ A({
    darkmode: { type: Boolean },
    locale: { default: "de" },
    cookieSettings: {}
  }, {
    show: { type: Boolean, default: !1 },
    showModifiers: {}
  }),
  emits: /* @__PURE__ */ A(["update:cookie-settings"], ["update:show"]),
  setup(k, { emit: c }) {
    const a = U(k, "show"), p = c, o = {
      infoText: {
        de: 'Mit Klick auf "Alle akzeptieren" wird der Speicherung von Cookies zur Marketing- und Analysezwecken auf diesem Gerät zugestimmt. Wir verwenden Cookies, um dir das bestmögliche Erlebnis auf dieser Webseite zu bieten. Weitere Informationen in unserer [Datenschutzerklärung](https://bluepic.io/privacy)',
        en: 'By clicking "Accept all", you agree to the storage of cookies for marketing and analysis purposes on this device. We use cookies to provide you with the best possible experience on this website. More information in our [privacy policy](https://bluepic.io/privacy)'
      },
      acceptAllLabel: {
        de: "Alle akzeptieren",
        en: "Accept all"
      },
      declineAllLabel: {
        de: "Ablehnen",
        en: "Decline"
      },
      cookieSettingsLabel: {
        de: "Cookie-Einstellungen",
        en: "Cookie settings"
      },
      cookieSettingsTitle: {
        de: "Cookie-Einstellungen",
        en: "Cookie settings"
      },
      cookieSettingsInfoText: {
        de: "Wir verwenden Cookies, um die Funktionalität der Website zu optimieren, Statistiken zu sammeln und Inhalte und Werbung zu liefern, die auf deine Interessen zugeschnitten sind. Detaillierte Beschreibungen der von uns verwendeten Cookies findest du in unserer Datenschutzerklärung.",
        en: "Wir verwenden Cookies, um die Funktionalität der Website zu optimieren, Statistiken zu sammeln und Inhalte und Werbung zu liefern, die auf deine Interessen zugeschnitten sind. Detaillierte Beschreibungen der von uns verwendeten Cookies findest du in unserer Datenschutzerklärung."
      },
      cookieSettingsNecessaryCookiesLabel: {
        de: "Erforderliche Cookies",
        en: "Necessary cookies"
      },
      cookieSettingsMarketingCookiesLabel: {
        de: "Marketing-Cookies",
        en: "Marketing cookies"
      },
      cookieSettingsMarketingCookiesText: {
        de: "Diese Cookies ermöglichen es uns, die Wirksamkeit unserer Anzeigen zu messen und auf deine Interessen abzustimmen.",
        en: "Diese Cookies ermöglichen es uns, die Wirksamkeit unserer Anzeigen zu messen und auf deine Interessen abzustimmen."
      },
      cookieSettingsAnalyticsCookiesLabel: {
        de: "Analytics-Cookies",
        en: "Analytics cookies"
      },
      cookieSettingsAnalyticsCookiesText: {
        de: "Dazu gehören Cookies, die helfen, die Leistung der Website zu überwachen, Nutzungsstatistiken zu erfassen und verbesserte Website-Funktionen und Personalisierung bereitzustellen.",
        en: "Dazu gehören Cookies, die helfen, die Leistung der Website zu überwachen, Nutzungsstatistiken zu erfassen und verbesserte Website-Funktionen und Personalisierung bereitzustellen."
      },
      cookieSettingsNecessaryLabel: {
        de: "notwenidg",
        en: "necessary"
      },
      cookieSettingsAcceptAllLabel: {
        de: "Alle akzeptieren",
        en: "Accept all"
      },
      cookieSettingsDeclineAllLabel: {
        de: "Alle ablehnen",
        en: "Decline all"
      },
      cookieSettingsAcceptCustomLabel: {
        de: "Auswahl akzeptieren",
        en: "Accept choice"
      }
    };
    function m(n) {
      var u;
      const l = (u = document.cookie.split("; ").find((f) => f.startsWith(`${n}=`))) == null ? void 0 : u.split("=")[1];
      return l ? decodeURIComponent(l) : void 0;
    }
    function i(n, l, u, f, E, V, $) {
      document.cookie = `${n}=${encodeURIComponent($)}; path=${l}; domain=${u}; max-age=${f}; ${E ? "Secure;" : ""} SameSite=${V}`;
    }
    const s = m("cookieConsent"), t = w(
      s ? JSON.parse(decodeURIComponent(s)) : {
        necessary: !1,
        marketing: !1,
        analysis: !1
      }
    );
    window.getCookieValue = m, window.setCookieValue = i, window.cookieSettings = t, W(
      t,
      () => {
        i("cookieConsent", "/", ".bluepic.io", 31536e3, !0, "None", JSON.stringify(t.value));
      },
      { deep: !0, immediate: !0 }
    );
    function _() {
      t.value = {
        necessary: !0,
        marketing: !0,
        analytics: !0
      }, a.value = !1, d.value = !1;
    }
    function S() {
      t.value = {
        necessary: !1,
        marketing: !1,
        analytics: !1
      }, a.value = !1, d.value = !1;
    }
    function x() {
      t.value.necessary = !0, a.value = !1, d.value = !1;
    }
    const d = w(!1);
    function T() {
      console.log("show cookie settings"), d.value = !0;
    }
    function B() {
      d.value = !1;
    }
    return P(() => {
      (Object.values(t.value).every((n) => n === !1) || s === void 0) && (a.value = !0);
    }), j(() => {
      console.log("cookieSettings changed", t.value), p("update:cookie-settings", t.value);
    }), (n, l) => (b(), C(R, null, [
      g(z, { name: "show-cookie-banner" }, {
        default: L(() => [
          a.value ? (b(), C("div", K, [
            e("div", {
              class: J(["cookie-banner", { "cookie-banner-hidden": d.value }])
            }, [
              e("div", q, [
                g(h, {
                  markdown: o.infoText[n.locale]
                }, null, 8, ["markdown"])
              ]),
              e("div", H, [
                e("button", {
                  class: "primary",
                  onClick: _
                }, r(o.acceptAllLabel[n.locale]), 1),
                e("button", { onClick: S }, r(o.declineAllLabel[n.locale]), 1)
              ]),
              e("div", Q, [
                e("button", { onClick: T }, r(o.cookieSettingsLabel[n.locale]), 1)
              ])
            ], 2)
          ])) : y("", !0)
        ]),
        _: 1
      }),
      g(z, { name: "show-cookie-settings-popup" }, {
        default: L(() => [
          d.value ? (b(), C("div", X, [
            e("div", Y, [
              e("header", null, [
                e("div", Z, [
                  e("h3", null, r(o.cookieSettingsTitle[n.locale]), 1)
                ]),
                e("div", { class: "actions" }, [
                  e("button", {
                    onClick: B,
                    style: { border: "none" }
                  }, l[2] || (l[2] = [
                    e("div", { class: "icon" }, [
                      e("svg", {
                        xmlns: "http://www.w3.org/2000/svg",
                        viewBox: "0 0 512 512"
                      }, [
                        e("path", {
                          "stroke-linecap": "round",
                          "stroke-linejoin": "round",
                          d: "M368 368L144 144M368 144L144 368"
                        })
                      ])
                    ], -1)
                  ]))
                ])
              ]),
              e("main", null, [
                e("div", ee, [
                  g(h, {
                    markdown: o.cookieSettingsInfoText[n.locale]
                  }, null, 8, ["markdown"])
                ]),
                e("div", oe, [
                  e("section", ne, [
                    e("header", null, [
                      e("div", te, r(o.cookieSettingsNecessaryCookiesLabel[n.locale]), 1),
                      e("div", ie, [
                        e("span", se, r(o.cookieSettingsNecessaryLabel[n.locale]), 1)
                      ])
                    ])
                  ]),
                  e("section", ae, [
                    e("header", null, [
                      e("div", le, r(o.cookieSettingsMarketingCookiesLabel[n.locale]), 1),
                      e("div", re, [
                        N(e("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": l[0] || (l[0] = (u) => t.value.marketing = u)
                        }, null, 512), [
                          [M, t.value.marketing]
                        ])
                      ])
                    ]),
                    e("div", ce, [
                      g(h, {
                        markdown: o.cookieSettingsMarketingCookiesText[n.locale]
                      }, null, 8, ["markdown"])
                    ])
                  ]),
                  e("section", ue, [
                    e("header", null, [
                      e("div", de, r(o.cookieSettingsAnalyticsCookiesLabel[n.locale]), 1),
                      e("div", ke, [
                        N(e("input", {
                          type: "checkbox",
                          "onUpdate:modelValue": l[1] || (l[1] = (u) => t.value.analytics = u)
                        }, null, 512), [
                          [M, t.value.analytics]
                        ])
                      ])
                    ]),
                    e("div", ge, [
                      g(h, {
                        markdown: o.cookieSettingsAnalyticsCookiesText[n.locale]
                      }, null, 8, ["markdown"])
                    ])
                  ])
                ])
              ]),
              e("footer", null, [
                e("button", {
                  class: "primary",
                  onClick: _
                }, r(o.cookieSettingsAcceptAllLabel[n.locale]), 1),
                e("button", { onClick: S }, r(o.cookieSettingsDeclineAllLabel[n.locale]), 1),
                e("button", {
                  class: "secondary",
                  onClick: x
                }, r(o.cookieSettingsAcceptCustomLabel[n.locale]), 1)
              ])
            ])
          ])) : y("", !0)
        ]),
        _: 1
      })
    ], 64));
  }
}), he = /* @__PURE__ */ I(pe, [["__scopeId", "data-v-99ba0636"]]);
export {
  he as CookieBanner
};
